import * as React from 'react';
import styles from './ProgressBar.scss';

export interface ProgressBarProps {
  /**
   * The length of the progress bar
   */
  total: number;
  /**
   * The active progress bar item
   */
  current: number;
}

export const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ ...props }) => {
  const itemWidth = 100 / props.total;
  const progressWidth = (props.current / props.total) * 100 - itemWidth / 2;

  const listItems: JSX.Element[] = [];
  for (let i = 1; i <= props.total; i++) {
    listItems.push(
      <li
        key={i}
        id={i.toString()}
        className={props.current == i ? styles['current'] : props.current > i ? styles['active'] : ''}
        style={{ width: itemWidth + '%' }}>
        <span className={styles['dot']}>
          <span aria-describedby={'step' + i + 'srdiv'}>{i}</span>
        </span>
      </li>,
    );
  }

  return (
    <>
      <div id="content-progressbar">
        <nav className={styles['progress-container']} role="navigation">
          <div
            className={props.current == props.total ? ['progress-steps', 'progress-steps-complete'].map((r) => styles[r]).join(' ') : styles['progress-steps']}>
            <span id="progress-percent" style={{ width: progressWidth + '%' }}></span>
          </div>
          <ul className={styles['section-nav']}>{listItems}</ul>
        </nav>
      </div>
    </>
  );
};
